var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M714.2,276.7c-5.4-16.6-21.5-28-44.1-31.3l-184.3-26.8l-82.4-167c-10.1-20.5-25.9-32.2-43.4-32.2 s-33.3,11.8-43.4,32.2l-82.4,167L49.9,245.4c-22.7,3.3-38.7,14.7-44.1,31.3s0.9,35.3,17.3,51.2l133.4,130L125,641.5 c-4,23.5,2.9,37.5,9.3,45.2c7.8,9.1,19.2,14.2,31.1,14c9.4,0,19.4-2.8,29.8-8.2L360,605.8l164.9,86.7c10.3,5.4,20.3,8.2,29.7,8.2 l0,0c11.9,0.2,23.4-4.9,31.1-14c6.5-7.7,13.3-21.7,9.3-45.2l-31.5-183.6l133.4-130C713.3,311.9,719.6,293.3,714.2,276.7z  M667.8,298.1L526.6,435.8c-4.9,4.8-7.2,11.7-6,18.5l33.3,194.4c0.8,3.4,0.8,6.9,0.2,10.4c-3.5-0.4-6.8-1.6-9.8-3.4l-174.6-91.8 c-6.1-3.2-13.3-3.2-19.4,0l-174.6,91.8c-3,1.8-6.3,2.9-9.8,3.4c-0.6-3.4-0.6-7,0.2-10.4l33.4-194.4c1.2-6.8-1.1-13.7-6-18.5 L52.2,298.1c-2.6-2.3-4.7-5.1-6.2-8.3c3.1-1.7,6.4-2.7,9.9-3L251,258.4c6.8-1,12.7-5.3,15.7-11.4l87.4-177c1.4-3.2,3.4-6.1,5.9-8.5 c2.5,2.4,4.6,5.3,6,8.5l87.3,176.9c3,6.2,8.9,10.4,15.7,11.4l195.2,28.4c3.5,0.3,6.9,1.4,9.9,3C672.6,292.9,670.5,295.7,667.8,298.1 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a99038d5adee300ece0814a7159d7fad.svg";
export { ForwardRef as ReactComponent };